import createReactComponent from '../createReactComponent';
export default createReactComponent('signal-4g', 'IconSignal4g', [
  ['path', { d: 'M6 8v3a1 1 0 0 0 1 1h3', key: 'svg-0' }],
  ['path', { d: 'M10 8v8', key: 'svg-1' }],
  [
    'path',
    { d: 'M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1', key: 'svg-2' },
  ],
]);
